export enum WebsiteUrlTypeEnum {
  Static = 'static',
  Dynamic = 'dynamic'
}
